// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-toolbar {
  display: block !important;
  --min-height: 2.5rem;
}
ion-toolbar .button {
  margin-top: 0;
  margin-bottom: 0;
  transform: translateY(0);
  z-index: 1;
}
ion-toolbar ion-title {
  transform: translateY(0);
  font-weight: 500;
  font-size: 2rem;
}
ion-toolbar .large-title {
  font-size: 1.2rem;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
@media screen and (max-width: 376px) {
  ion-toolbar h5 {
    font-size: 1rem;
  }
}

ion-ripple-effect {
  color: var(--ion-color-light);
}

ion-button {
  width: 4rem;
  height: 2.5em;
  transform: translateY(-8px);
  --background-hover-opacity: 0;
}
@media screen and (max-width: 550px) {
  ion-button {
    --padding-top: .25rem;
    --padding-bottom: .25rem;
    min-height: 0;
    height: 2rem;
  }
}

ion-title {
  text-align: center;
  transform: translateY(-0.5rem);
}

ion-button.cursor-no {
  cursor: none;
  visibility: hidden;
}

@media screen and (max-width: 550px) {
  ion-toolbar .large-title {
    font-size: 1rem;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  ion-title {
    font-size: 0.75rem !important;
  }
}
.ios-button-styling {
  padding-top: 0%;
}

.text-overflow {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.custom-toolbar {
  padding-top: 0px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/lobby/custom-navbar/custom-navbar.component.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;EACA,oBAAA;AACJ;AACI;EACI,aAAA;EACA,gBAAA;EACA,wBAAA;EACA,UAAA;AACR;AAEI;EACI,wBAAA;EACA,gBAAA;EACA,eAAA;AAAR;AAGI;EACI,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AADR;AAIQ;EADJ;IAEI,eAAA;EADN;AACF;;AAKA;EACI,6BAAA;AAFJ;;AAKA;EACI,WAAA;EACA,aAAA;EAEA,2BAAA;EACA,6BAAA;AAHJ;AAKI;EAPJ;IAQQ,qBAAA;IACA,wBAAA;IACA,aAAA;IACA,YAAA;EAFN;AACF;;AAKA;EACI,kBAAA;EACA,8BAAA;AAFJ;;AAKA;EACI,YAAA;EACA,kBAAA;AAFJ;;AAKA;EAEQ;IACI,eAAA;IACA,uBAAA;IACA,mBAAA;IACA,gBAAA;EAHV;EAOE;IACI,6BAAA;EALN;AACF;AASA;EACI,eAAA;AAPJ;;AAUA;EACI,gBAAA;EACA,uBAAA;EACA,mBAAA;AAPJ;;AAUA;EACI,gBAAA;AAPJ","sourcesContent":["ion-toolbar {\n    display: block !important;\n    --min-height: 2.5rem;\n\n    .button {\n        margin-top: 0;\n        margin-bottom: 0;\n        transform: translateY(0);\n        z-index: 1;\n    }\n\n    ion-title {\n        transform: translateY(0);\n        font-weight: 500;\n        font-size: 2rem;\n    }\n\n    .large-title {\n        font-size: 1.2rem;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        overflow: hidden;\n    }\n    h5 {\n        @media screen and (max-width: 376px) {\n        font-size:1rem;\n        }\n    }\n}\n\nion-ripple-effect {\n    color: var(--ion-color-light);\n}\n\nion-button {\n    width: 4rem;\n    height: 2.5em;\n\n    transform: translateY(-8px);\n    --background-hover-opacity: 0;\n\n    @media screen and (max-width: 550px) {\n        --padding-top: .25rem;\n        --padding-bottom: .25rem;\n        min-height: 0;\n        height: 2rem;\n    }\n}\n\nion-title {\n    text-align: center;\n    transform: translateY(-.5rem);\n}\n\nion-button.cursor-no {\n    cursor: none;\n    visibility: hidden;\n}\n\n@media screen and (max-width: 550px) {\n    ion-toolbar{\n        .large-title {\n            font-size: 1rem;\n            text-overflow: ellipsis;\n            white-space: nowrap;\n            overflow: hidden;\n        }\n    }\n\n    ion-title {\n        font-size: .75rem !important;\n    }\n\n}\n\n.ios-button-styling {\n    padding-top: 0%;\n}\n\n.text-overflow {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.custom-toolbar {\n    padding-top: 0px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
